// istanbul ignore file
import * as saveBookmarkService from '../services/saveBookmarkService'
import * as getBookmarkListDataService from '../services/getBookmarkService'
import * as deleteBookmarkService from '../services/deleteBookmarkService'
import {
  SaveBookmarkDataErrorAction,
  SaveBookmarkDataLoadingAction,
  SaveBookmarkDataUpdateAction
} from './toggleBookmarkSlice'
import {
  GetBookmarkDataErrorAction,
  GetBookmarkDataLoadingAction,
  GetBookmarkDataUpdateAction
} from './getBookmarkSlice'

export const saveBookmarkDataservice =
  (subId: string, requestParameter: any) => async (dispatch: any) => {
    dispatch(SaveBookmarkDataLoadingAction())
    try {
      await saveBookmarkService.SaveBookmarkService(
        subId,
        requestParameter,
        (SaveBookmarkData, httpStatus) => {
          dispatch(
            SaveBookmarkDataUpdateAction({ data: SaveBookmarkData, httpStatus })
          )
          dispatch(getBookmarkListDataservice(subId))
        },
        (errorMessage, httpStatus) => {
          dispatch(SaveBookmarkDataErrorAction({ errorMessage, httpStatus }))
        },
        () => {
          //
        }
      )
    } catch (e: any) {
      // istanbul ignore next
      dispatch(
        SaveBookmarkDataErrorAction({
          errorMessage: e.response.message,
          httpStatus: e.response.status
        })
      )
    }
  }
export const getBookmarkListDataservice =
  (subId: string) => async (dispatch: any) => {
    dispatch(GetBookmarkDataLoadingAction())
    try {
      await getBookmarkListDataService.getBookmarkListDataService(
        subId,
        (GetBookmarkData, httpStatus) => {
          dispatch(
            GetBookmarkDataUpdateAction({ data: GetBookmarkData, httpStatus })
          )
        },
        (errorMessage, httpStatus) => {
          dispatch(GetBookmarkDataErrorAction({ errorMessage, httpStatus }))
        }
      )
    } catch (e: any) {
      // istanbul ignore next
      dispatch(
        GetBookmarkDataErrorAction({
          errorMessage: e.response.message,
          httpStatus: e.response.status
        })
      )
    }
  }
export const deleteBookmarkservice =
  (subId: string, dashboardId: string) => async (dispatch: any) => {
    dispatch(SaveBookmarkDataLoadingAction())
    try {
      await deleteBookmarkService.deleteBookmarkService(
        dashboardId,
        (DeleteBookmarkData, httpStatus) => {
          dispatch(
            SaveBookmarkDataUpdateAction({
              data: DeleteBookmarkData,
              httpStatus
            })
          )
          dispatch(getBookmarkListDataservice(subId))
        },
        (errorMessage, httpStatus) => {
          dispatch(SaveBookmarkDataErrorAction({ errorMessage, httpStatus }))
        },
        () => {
          // Error block
        }
      )
    } catch (e: any) {
      // istanbul ignore next
      dispatch(
        SaveBookmarkDataErrorAction({
          errorMessage: e.response.message,
          httpStatus: e.response.status
        })
      )
    }
  }
